module.exports = __webpack_public_path__ + "img/WL4.538df1b6.svg";